var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "rounded-0" },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h3", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.addressConfirmForm.title")) +
                  "\n        "
              ),
              _c("small", { staticClass: "text-muted mx-2" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("message.addressConfirmForm.subtitle")) +
                    "\n        "
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "d-flex justify-content-center mt-4" },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("address-form", {
                ref: "addressForm",
                attrs: { address: _vm.currentAddress, onSubmitFn: _vm.submit }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-button",
                { attrs: { variant: "link" }, on: { click: _vm.back } },
                [_vm._v(_vm._s(_vm.$t("message.addressConfirmForm.btn.back")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right", attrs: { cols: "6" } },
            [
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.submit } },
                [
                  _vm._v(
                    _vm._s(_vm.$t("message.addressConfirmForm.btn.submit"))
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c2629bb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c2629bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/address/AddressConfirmForm.vue
// module id = nFNx
// module chunks = 1